// extracted by mini-css-extract-plugin
export default {"container":"CookiePermission_container__5R7Ml","column":"CookiePermission_column__6Sgz3","closed":"CookiePermission_closed__auk6z"};